/**
 * Philippine peso.
 */
export var PHP = {
  code: 'PHP',
  base: 10,
  exponent: 2
};